/**
 * Hero Carousel Component
 * Main carousel containing game slides
 */
import { useMemo } from 'react';
import GameSlide from './GameSlide';
import { navigateToSection, navigateToStockFor } from '../../utils/navigation';

const HeroCarousel = ({
  games,
  carouselRef,
  handleScroll,
  setHasSelectedGame,
  currentGameIndex,
  setCurrentGameIndex,
  isMobile,
  shineDisabled,
  setShineDisabled,
}) => {
  const carouselClasses = useMemo(
    () =>
      `scrollbar-none flex h-full w-full snap-x snap-mandatory overflow-x-auto transition-opacity duration-300 md:overflow-hidden ${
        isMobile ? 'touch-pan-x overscroll-x-none' : 'touch-pan-x scroll-smooth'
      }`,
    [isMobile],
  );

  const handlePackClick = (packName) => {
    navigateToStockFor(
      packName,
      currentGameIndex,
      setCurrentGameIndex,
      setHasSelectedGame,
    );
  };

  const handleNavigateToStock = () => {
    navigateToSection('stock');
  };

  return (
    <div
      ref={carouselRef}
      onScroll={() => {
        handleScroll();
        setHasSelectedGame(true);
      }}
      className={carouselClasses}
      style={{
        scrollSnapStop: 'always',
        WebkitOverflowScrolling: 'touch',
        scrollPaddingInline: '0px',
      }}
    >
      {games.map((game, idx) => (
        <GameSlide
          key={idx}
          game={game}
          idx={idx}
          shineDisabled={shineDisabled}
          setShineDisabled={setShineDisabled}
          onNavigateToStock={handleNavigateToStock}
          onPackClick={handlePackClick}
        />
      ))}
    </div>
  );
};

export default HeroCarousel;
